import { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { RootState } from "../../state/configureStore";
import { connect } from "react-redux";
import ReadleeProfile from "../../services/firebase/ReadleeProfile";
import Loading from "../Loading/Loading";

interface JoinClassRedirectScreenProps {
  profile: ReadleeProfile | undefined;
  isConnectingUser: boolean;
}

const JoinClassRedirectScreen = ({ isConnectingUser, profile }: JoinClassRedirectScreenProps) => {
  const { classCode } = useParams<{ classCode: string }>();
  const history = useHistory();
  useEffect(() => {
    if (isConnectingUser) return;
    if (!isConnectingUser && profile?.lastLoginDay && !profile.uid) return;

    if (profile?.userType === "student") {
      return history.push(`/?joinClass=${classCode}`);
    }
    return history.push(`/sign-up?userType=student&classCode=${classCode}`);
  });

  return isConnectingUser ? <Loading /> : null;
};

const mapStateToProps = (state: RootState): JoinClassRedirectScreenProps => ({
  profile: state.currentUserState.currentUser,
  isConnectingUser: state.currentUserState.isConnectingUser,
});

export default connect(mapStateToProps)(JoinClassRedirectScreen);
